export const IconShare = ({ className }: { className?: string }) => (
  <svg className={`fill-current ${className}`} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9986 15C17.213 15.0006 16.459 15.3094 15.8986 15.86L7.99856 12.34V12V11.67L15.8986 8.13999C17.0818 9.29979 18.9812 9.28079 20.141 8.09756C21.3008 6.91433 21.2818 5.01493 20.0986 3.85513C18.9153 2.69533 17.0159 2.71433 15.8561 3.89756C15.3059 4.45895 14.9979 5.21389 14.9986 5.99999V6.33999L7.09856 9.85999C5.91667 8.69883 4.01725 8.71563 2.85609 9.89752C1.69493 11.0794 1.71173 12.9788 2.89362 14.14C4.06075 15.2867 5.93144 15.2867 7.09857 14.14L14.9986 17.67V18V18C14.9986 19.6568 16.3417 21 17.9986 21C19.6554 21 20.9986 19.6568 20.9986 18C20.9986 16.3431 19.6554 15 17.9986 15L17.9986 15Z"
    />
  </svg>
)
